import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { useFitText } from './useFitText';
import { GetCardBackground } from './GetCardBackground';
import { GetCardTextColor } from './GetCardTextColor';
import { GetCardBorderColor } from './GetCardBorderColor';


const StyledCard = styled(Box)(({ theme, background }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  
  minHeight: '300px', // fallback safety
  width: 'clamp(200px, min(70vw, 39.2vh), 500px)',
  
  aspectRatio: '2.5 / 3.5',
  borderRadius: theme.spacing(2),
  padding: `${theme.spacing(5)} ${theme.spacing(2)}`,
  background,

  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.4)',
  color: '#e5d7ff',
  overflow: 'hidden',
  fontFamily: 'Inter, sans-serif',
  justifyContent: 'flex-start',
  alignItems: 'center',
  textAlign: 'center',

  '&::before': {
    content: '""',
    position: 'absolute',
    top: 16,
    left: 16,
    right: 16,
    bottom: 16,
    borderRadius: 12,
    border: '2px solid rgba(255, 255, 255, 0.05)',
    pointerEvents: 'none',
  },

  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    width: '80%',
    height: 40,
    background: 'radial-gradient(circle, rgba(255, 100, 100, 0.2), transparent 70%)',
    borderRadius: '50%',
    filter: 'blur(20px)',
    zIndex: 0,
  },  
}));

const StyledQuestionText = styled(Box)(({ theme }) => ({
    fontFamily: 'Playfair Display, serif',
    color: '#ffbfe5',
    fontWeight: 'bold',
    textShadow: '0px 4px 6px rgba(0, 0, 0, 0.4)',
    textAlign: 'center',
    zIndex: 1,
    width: '100%',
    height: '100%',
    maxHeight: '100%', // prevent overflow breaking box
    lineHeight: 1.3,
    overflow: 'hidden',
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: theme.spacing(1), // = 8px
    boxSizing: 'border-box',
    overflowY: 'auto',
scrollbarWidth: 'thin', // Firefox
scrollbarColor: 'rgba(255, 191, 229, 0.4) rgba(0, 0, 0, 0.3)',

'&::-webkit-scrollbar': {
  width: '6px',
},
'&::-webkit-scrollbar-thumb': {
  background: 'linear-gradient(to bottom, #C5449C, #73165A)',
  borderRadius: '8px',
},
'&::-webkit-scrollbar-track': {
  background: 'rgba(255, 255, 255, 0.05)',
  borderRadius: '8px',
},

  }));


const DeeperCard = ({typeOfDare, question, attributes}) => {
    const { ref, fontSize } = useFitText({ minFontSize: 14, maxFontSize: 24 });
    const background = GetCardBackground(typeOfDare);
    const textColor = GetCardTextColor(typeOfDare);
    const borderColor = GetCardBorderColor(typeOfDare);
    const isTruth = typeOfDare === 'Truth';
    const isLightDare = typeOfDare === 'Light Dare';
    const isDare = typeOfDare === 'Dare';
    const useImage = isTruth || isLightDare || isDare;
    const bgImage = isTruth
      ? "url('/gamepictures/truthbackground.webp')"
      : isLightDare
      ? "url('/gamepictures/lightdarebackground.webp')"
      : isDare
      ? "url('/gamepictures/darebackground.webp')"
      : undefined;
  return (
    <StyledCard
      data-question-card
      background={useImage ? 'none' : background}
      sx={{
        border: `1px solid ${borderColor}`,
        boxShadow: `0 4px 20px rgba(0, 0, 0, 0.4), 0 0 14px ${borderColor}`,
        ...(useImage ? {
          backgroundImage: bgImage,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        } : {}),
      }}
    >
      <StyledQuestionText ref={ref} sx={{ fontSize, color: textColor, WebkitTextStroke: isLightDare ? '1px rgba(0, 0, 0, 0.7)' : '1px rgba(0, 0, 0, 0.1)', paintOrder: 'stroke fill' }}>
    {question}
  </StyledQuestionText>
</StyledCard>

  );
};

export default DeeperCard;

// import React from 'react';
// import { Box, Typography } from '@mui/material';
// import { styled } from '@mui/system';
// import { useFitText } from './useFitText';



// const StyledCard = styled(Box)(({ theme }) => ({
//   position: 'relative',
//   width: 'min(90vw, 300px)',
//   display: 'flex',
//   flexDirection: 'column',
//   minWidth: '150px',
//   maxWidth: '300px',
//   minHeight: '210px',
//   maxHeight: '420px',
//   aspectRatio: '2.5 / 3.5',
//   borderRadius: theme.spacing(2),
//   padding: `${theme.spacing(5)} ${theme.spacing(2)}`,
//   background: 'linear-gradient(to bottom, #1a0f2d, #241135, #3a113c)',
//   boxShadow: '0 4px 20px rgba(0, 0, 0, 0.4)',
//   overflow: 'hidden',
//   color: '#e5d7ff',
//   fontFamily: 'Inter, sans-serif',
//   justifyContent: 'flex-start',
//   alignItems: 'center',
//   textAlign: 'center',

//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: 16,
//     left: 16,
//     right: 16,
//     bottom: 16,
//     borderRadius: 12,
//     border: '2px solid rgba(255, 255, 255, 0.05)',
//     pointerEvents: 'none',
//   },

//   '&::after': {
//     content: '""',
//     position: 'absolute',
//     bottom: 0,
//     left: '50%',
//     transform: 'translateX(-50%)',
//     width: '80%',
//     height: 40,
//     background: 'radial-gradient(circle, rgba(255, 100, 100, 0.2), transparent 70%)',
//     borderRadius: '50%',
//     filter: 'blur(20px)',
//     zIndex: 0,
//   },
// }));

// const StyledQuestionText = styled(Box)(({ theme }) => ({
//     fontFamily: 'Playfair Display, serif',
//     color: '#ffbfe5',
//     fontWeight: 'bold',
//     textShadow: '0px 4px 6px rgba(0, 0, 0, 0.4)',
//     textAlign: 'center',
//     zIndex: 1,
//     width: '100%',
//     height: '100%',
//     lineHeight: 1.3,
//     overflow: 'hidden',
//     overflowWrap: 'break-word',
//     wordBreak: 'break-word',
//     display: 'flex',
//     alignItems: 'flex-start',
//     justifyContent: 'center',
//     padding: theme.spacing(1), // = 8px
//     boxSizing: 'border-box',
//   }));


// const DeeperCard = ({typeOfDare, question, attributes}) => {
//     const { ref, fontSize } = useFitText({ minFontSize: 14, maxFontSize: 24 });
//   return (
//     <StyledCard>
//       <Typography
//         variant="h4"
//         sx={{
//             fontFamily: 'Playfair Display, serif',
//             // fontWeight:'bold',
//             background: 'linear-gradient(176deg, #C5449C 0%, #73165A 60%)',
//             WebkitBackgroundClip: 'text',
//             WebkitTextFillColor: 'transparent',
//             textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
//             marginBottom: '1rem',
//             textAlign: 'center',
//         }}
//       >
//         {typeOfDare}
//       </Typography>
        
//       <StyledQuestionText ref={ref} sx={{ fontSize }}>
//     {question}
//   </StyledQuestionText>
// </StyledCard>
    
//   );
// };

// export default DeeperCard;